import { CSS, Transform } from '@dnd-kit/utilities';
import { rgba } from 'polished';
import { index, Options } from 'shared/assets/styles/z-index';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: ${({ theme }) => `0 ${theme.spacing(2.5)} ${theme.spacing(2)}`};
`;

// Horizontal padding lives here, not on Container: this scroll box is what clips a dragged section's shadow.
export const Sections = styled.div`
  flex: 1;
  overflow: auto;
  padding: ${({ theme }) => `0 ${theme.spacing(1)} ${theme.spacing(4)}`};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ListItem = styled.li``;

export const Section = styled.div<{
  $isFirst: boolean;
  $isDragging: boolean;
  $transform: Transform | null;
  $transition?: string;
}>`
  position: relative;
  transform: ${({ $transform }) => CSS.Translate.toString($transform)};
  transition: ${({ $transition }) => $transition};
  margin-top: ${({ $isFirst, theme }) => ($isFirst ? 0 : theme.spacing(3))};

  ${({ $isDragging, theme }) =>
    $isDragging &&
    css`
      z-index: ${index(Options.DND_MOVING_ITEM)};
      border-radius: ${theme.spacing(2.5)};
      background: ${theme.palette.background.default};
      box-shadow: ${theme.shadowBox.menu};
    `};
`;

export const SectionHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing(1.75)} ${theme.spacing(2)} ${theme.spacing(1.75)} ${theme.spacing(3)}`};

  appearance: none;
  border: none;
  background: transparent;
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => rgba(theme.palette.text.primary, 0.06)};
  }
`;

export const SectionTitle = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const SectionCount = styled.span`
  margin-left: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;
